/* ══════════════════════════════════════════════════════════
   Bakalar Coffee Roasters — Theme JavaScript
   bakalar-liquid-v1
   ══════════════════════════════════════════════════════════ */

/* ── MOBILE MENU ── */
function toggleMobileMenu() {
  var links = document.getElementById('nav-links');
  var burger = document.querySelector('.hamburger');
  if (links && burger) {
    links.classList.toggle('open');
    burger.classList.toggle('open');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  /* Close mobile menu on link click */
  document.querySelectorAll('#nav-links a').forEach(function (a) {
    a.addEventListener('click', function () {
      document.getElementById('nav-links').classList.remove('open');
      document.querySelector('.hamburger').classList.remove('open');
    });
  });
});

/* ── CART PANEL ── */
function toggleCart() {
  var panel = document.getElementById('cart-panel');
  var overlay = document.getElementById('cart-overlay');
  if (!panel) return;
  var isOpen = panel.classList.contains('open');
  panel.classList.toggle('open', !isOpen);
  overlay.classList.toggle('open', !isOpen);
  if (!isOpen) fetchCart();
}

function fetchCart() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCart(cart); })
    .catch(function (e) { console.error('Cart fetch error:', e); });
}

function renderCart(cart) {
  var list = document.getElementById('cart-items-list');
  var bottom = document.getElementById('cart-bottom');
  if (!list || !bottom) return;

  if (cart.item_count === 0) {
    list.innerHTML = '<p class="cart-empty">Tu carrito está vacío.</p>';
    bottom.style.display = 'none';
    return;
  }

  list.innerHTML = cart.items.map(function (item) {
    var img = item.image ? '<img src="' + item.image + '" alt="" style="width:48px;height:48px;border-radius:6px;object-fit:cover;flex-shrink:0">' : '';
    return '<div class="cart-item">'
      + '<div style="display:flex;gap:12px;align-items:center">'
      + img
      + '<div>'
      + '<div class="cart-item-name">' + item.product_title + '</div>'
      + (item.variant_title ? '<div style="font-size:11px;color:var(--mid)">' + item.variant_title + '</div>' : '')
      + '<div class="cart-item-qty">'
      + '<button onclick="changeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>'
      + '<span style="font-size:13px;min-width:18px;text-align:center">' + item.quantity + '</span>'
      + '<button onclick="changeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>'
      + '</div>'
      + '</div></div>'
      + '<span class="cart-item-price">€' + (item.final_line_price / 100).toFixed(2) + '</span>'
      + '</div>';
  }).join('');

  document.getElementById('cart-total-val').textContent = '€' + (cart.total_price / 100).toFixed(2);
  bottom.style.display = 'block';

  updateCartCount(cart.item_count);

  /* Wholesale soft-gate in slide-out panel */
  var existingNotice = document.getElementById('cart-panel-wholesale');
  if (existingNotice) existingNotice.remove();

  if (window.isWholesale) {
    var threshold = 4000;
    var totalWeight = cart.items.reduce(function (sum, item) {
      return sum + (item.grams * item.quantity);
    }, 0);
    var remaining = Math.max(0, threshold - totalWeight);
    var pct = Math.min(100, Math.round((totalWeight / threshold) * 100));
    var checkoutLink = document.querySelector('.cart-checkout');

    var notice = document.createElement('div');
    notice.id = 'cart-panel-wholesale';
    notice.className = 'wholesale-notice';
    notice.style.marginTop = '1rem';

    if (remaining > 0) {
      var remainText = remaining >= 1000 ? (remaining / 1000).toFixed(1) + ' kg' : remaining + 'g';
      notice.innerHTML = '<strong>Cuenta mayorista</strong> — pedido minimo 4 kg de cafe.'
        + '<div style="margin-top:4px;font-size:12px">Anade ' + remainText + ' mas para alcanzar el minimo.</div>'
        + '<div class="weight-progress" style="margin-top:8px"><div class="weight-progress-bar" style="width:' + pct + '%"></div></div>';
      if (checkoutLink) {
        checkoutLink.style.opacity = '0.5';
        checkoutLink.style.pointerEvents = 'none';
      }
    } else {
      notice.innerHTML = '<strong>Cuenta mayorista</strong> — minimo alcanzado!'
        + '<div class="weight-progress" style="margin-top:8px"><div class="weight-progress-bar" style="width:100%"></div></div>';
      if (checkoutLink) {
        checkoutLink.style.opacity = '';
        checkoutLink.style.pointerEvents = '';
      }
    }

    bottom.insertBefore(notice, bottom.firstChild);
  }
}

function changeQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: String(key), quantity: qty })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCart(cart);
      updateCartCount(cart.item_count);
    });
}

function addToCart(variantId, qty) {
  qty = qty || 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      fetchCart();
      toggleCart();
    })
    .catch(function (e) { console.error('Add to cart error:', e); });
}

function updateCartCount(count) {
  var el = document.getElementById('cart-count');
  if (el) el.textContent = count;
  var badge = document.getElementById('cart-badge');
  if (badge) {
    badge.textContent = count;
    if (count > 0) {
      badge.classList.remove('is-empty');
    } else {
      badge.classList.add('is-empty');
    }
  }
}

/* Update count on page load */
document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); })
    .catch(function () {});
});

/* ── FAQ ACCORDION ── */
function toggleFaqAcc(id) {
  var acc = document.getElementById(id);
  if (!acc) return;
  var body = acc.querySelector('.faq-acc-a');
  if (acc.classList.contains('open')) {
    acc.classList.remove('open');
    body.style.maxHeight = '0px';
  } else {
    acc.classList.add('open');
    body.style.maxHeight = body.scrollHeight + 'px';
  }
}

/* Recalculate open accordion heights on resize */
window.addEventListener('resize', function () {
  document.querySelectorAll('.faq-acc.open .faq-acc-a').forEach(function (body) {
    body.style.maxHeight = body.scrollHeight + 'px';
  });
});

/* ── PRODUCT VARIANT SELECTOR ── */
function selectProductVariant(el) {
  el.closest('.prod-sizes').querySelectorAll('.size-opt').forEach(function (o) {
    o.classList.remove('active');
  });
  el.classList.add('active');

  var variantId = el.dataset.variantId;
  var price = parseInt(el.dataset.variantPrice, 10);

  /* Update displayed price */
  var priceEl = document.getElementById('product-price');
  if (priceEl && price) {
    priceEl.textContent = '€' + (price / 100).toFixed(2);
  }

  /* Update add-to-cart button's variant ID */
  var btn = document.getElementById('add-to-cart-btn');
  if (btn) {
    btn.dataset.variantId = variantId;
  }
}

/* ── EQUIPMENT FILTERS ── */
(function () {
  var activeFilters = {};

  document.addEventListener('DOMContentLoaded', function () {
    var wrap = document.getElementById('eq-filters');
    if (!wrap) return;

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.eq-filter-btn');
      if (!btn) return;
      var key = btn.dataset.key;
      var value = btn.dataset.value;

      btn.closest('.eq-filter-group').querySelectorAll('.eq-filter-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
      activeFilters[key] = value;

      document.querySelectorAll('.eq-card').forEach(function (card) {
        var visible = true;
        for (var k in activeFilters) {
          if (activeFilters[k] !== 'all' && card.dataset[k] !== activeFilters[k]) visible = false;
        }
        card.style.display = visible ? '' : 'none';
      });
    });
  });
})();

/* ── WHOLESALE SOFT-GATE (cart page) ──
   For wholesale-tagged customers: sums weight of coffee products in cart.
   If under threshold, disables checkout button with progress message.
   Threshold in grams, set via data attribute on the wholesale notice element.
   ──────────────────────────────────────────────────────── */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var notice = document.getElementById('wholesale-notice');
    if (!notice) return;

    var threshold = parseInt(notice.dataset.threshold, 10) || 4000; /* default 4kg */
    var checkoutBtn = document.querySelector('.cart-checkout-btn');

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var totalWeight = cart.items.reduce(function (sum, item) {
          return sum + (item.grams * item.quantity);
        }, 0);

        var pct = Math.min(100, Math.round((totalWeight / threshold) * 100));
        var remaining = Math.max(0, threshold - totalWeight);

        var bar = notice.querySelector('.weight-progress-bar');
        if (bar) bar.style.width = pct + '%';

        var msg = notice.querySelector('.weight-msg');
        if (msg) {
          if (remaining > 0) {
            msg.textContent = 'Añade ' + (remaining >= 1000 ? (remaining / 1000).toFixed(1) + ' kg' : remaining + 'g') + ' más para alcanzar el mínimo mayorista.';
          } else {
            msg.textContent = '¡Mínimo mayorista alcanzado!';
          }
        }

        if (checkoutBtn) {
          if (remaining > 0) {
            checkoutBtn.disabled = true;
            checkoutBtn.style.opacity = '0.5';
            checkoutBtn.style.cursor = 'not-allowed';
          } else {
            checkoutBtn.disabled = false;
            checkoutBtn.style.opacity = '';
            checkoutBtn.style.cursor = '';
          }
        }
      });
  });
})();